import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: {
        '@$': 'title',
      },
      type: 'table',
      content: {
        if: [
          [
            {
              '=': [
                {
                  '@$': 'piSwitch',
                },
                true,
              ],
            },
            {
              '{}': {
                count: {
                  '`': {
                    selection: {
                      '#': {
                        '@': 'employees',
                      },
                    },
                    subqueries: {
                      employees: {
                        filter: {
                          or: [
                            {
                              '=': [
                                {
                                  '``': {
                                    '@$': 'orgRecordId',
                                  },
                                },
                                null,
                              ],
                            },
                            {
                              in: [
                                {
                                  '[]': [
                                    {
                                      '``': {
                                        '@$': 'orgRecordId',
                                      },
                                    },
                                  ],
                                },
                                {
                                  '@': 'projectOrgs',
                                },
                              ],
                            },
                          ],
                        },
                        target: 'ent:!personnel:!employee',
                        selection: {
                          '@.': '!id',
                        },
                        subqueries: {
                          projects: {
                            ref: {
                              attr: 'attr:ent#!proj_pis#!entry:!proj',
                            },
                            using: 'projectPiAssignments',
                            filter: {
                              or: [
                                {
                                  '=': [
                                    {
                                      '``': {
                                        '@$': 'orgRecordId',
                                      },
                                    },
                                    null,
                                  ],
                                },
                                {
                                  '=': [
                                    {
                                      '@.': [
                                        '!org',
                                        {
                                          ref: {
                                            entity: {
                                              '``': {
                                                '@$': 'orgEntityId',
                                              },
                                            },
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      '``': {
                                        '@$': 'orgRecordId',
                                      },
                                    },
                                  ],
                                },
                              ],
                            },
                            target: 'ent:!projects:!proj',
                          },
                          projectOrgs: {
                            ref: {
                              attr: 'attr:ent#!proj_pis#!entry:!proj',
                            },
                            using: 'projectPiAssignments',
                            filter: {
                              '!=': [
                                {
                                  '@': 'organizations',
                                },
                                {
                                  '[]': [],
                                },
                              ],
                            },
                            target: 'ent:!projects:!proj',
                            selection: {
                              '@': 'organizations',
                            },
                            subqueries: {
                              organizations: {
                                ref: {
                                  attr: 'attr:ent#!projects#!proj:!org',
                                },
                                filter: {
                                  if: [
                                    [
                                      {
                                        '=': [
                                          {
                                            '``': {
                                              '@$': 'shouldAnalyze',
                                            },
                                          },
                                          true,
                                        ],
                                      },
                                      {
                                        '=': [
                                          {
                                            '@.': '!should_analyze',
                                          },
                                          true,
                                        ],
                                      },
                                    ],
                                    true,
                                  ],
                                },
                                target: 'dim::!org',
                                selection: {
                                  '@.': '!id',
                                },
                              },
                            },
                          },
                          expenses2020: {
                            ref: {
                              attr: 'attr:ent#!gl_exp#!entry:!proj',
                            },
                            using: 'projects',
                            filter: {
                              and: [
                                {
                                  if: [
                                    [
                                      {
                                        '=': [
                                          {
                                            '``': {
                                              '@$': 'financialVolume',
                                            },
                                          },
                                          'MTDC',
                                        ],
                                      },
                                      {
                                        '@': 'isInMtdc',
                                      },
                                    ],
                                    true,
                                  ],
                                },
                                {
                                  or: [
                                    {
                                      '=': [
                                        {
                                          '`': {
                                            '``': {
                                              '@$': 'researchType',
                                            },
                                          },
                                        },
                                        null,
                                      ],
                                    },
                                    {
                                      in: [
                                        {
                                          '@': 'researchType',
                                        },
                                        {
                                          '`': {
                                            '``': {
                                              '@$': 'researchType',
                                            },
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              ],
                            },
                            period: {
                              $range: {
                                end: {
                                  $date: '12/31/2020',
                                },
                                start: {
                                  $date: '1/1/2020',
                                },
                              },
                            },
                            target: 'ent:!gl_exp:!entry',
                            selection: {
                              '@.': '!amount',
                            },
                            subqueries: {
                              isInMtdc: {
                                ref: {
                                  attr: 'attr:ent#!gl_exp#!entry:!acct',
                                },
                                target: 'ent:!gl_accts:!acct',
                                selection: {
                                  '@.': '!is_in_mtdc',
                                },
                              },
                              researchType: {
                                ref: {
                                  attr: 'attr:ent#!gl_exp#!entry:!proj',
                                },
                                target: 'ent:!projects:!proj',
                                selection: {
                                  '@.': '!research_type_wfuhs',
                                },
                              },
                            },
                          },
                          expenses2021: {
                            ref: {
                              attr: 'attr:ent#!gl_exp#!entry:!proj',
                            },
                            using: 'projects',
                            filter: {
                              and: [
                                {
                                  if: [
                                    [
                                      {
                                        '=': [
                                          {
                                            '``': {
                                              '@$': 'financialVolume',
                                            },
                                          },
                                          'MTDC',
                                        ],
                                      },
                                      {
                                        '@': 'isInMtdc',
                                      },
                                    ],
                                    true,
                                  ],
                                },
                                {
                                  or: [
                                    {
                                      '=': [
                                        {
                                          '`': {
                                            '``': {
                                              '@$': 'researchType',
                                            },
                                          },
                                        },
                                        null,
                                      ],
                                    },
                                    {
                                      in: [
                                        {
                                          '@': 'researchType',
                                        },
                                        {
                                          '`': {
                                            '``': {
                                              '@$': 'researchType',
                                            },
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              ],
                            },
                            period: {
                              $range: {
                                end: {
                                  $date: '12/31/2021',
                                },
                                start: {
                                  $date: '1/1/2021',
                                },
                              },
                            },
                            target: 'ent:!gl_exp:!entry',
                            selection: {
                              '@.': '!amount',
                            },
                            subqueries: {
                              isInMtdc: {
                                ref: {
                                  attr: 'attr:ent#!gl_exp#!entry:!acct',
                                },
                                target: 'ent:!gl_accts:!acct',
                                selection: {
                                  '@.': '!is_in_mtdc',
                                },
                              },
                              researchType: {
                                ref: {
                                  attr: 'attr:ent#!gl_exp#!entry:!proj',
                                },
                                target: 'ent:!projects:!proj',
                                selection: {
                                  '@.': '!research_type_wfuhs',
                                },
                              },
                            },
                          },
                          expenses2022: {
                            ref: {
                              attr: 'attr:ent#!gl_exp#!entry:!proj',
                            },
                            using: 'projects',
                            filter: {
                              and: [
                                {
                                  if: [
                                    [
                                      {
                                        '=': [
                                          {
                                            '``': {
                                              '@$': 'financialVolume',
                                            },
                                          },
                                          'MTDC',
                                        ],
                                      },
                                      {
                                        '@': 'isInMtdc',
                                      },
                                    ],
                                    true,
                                  ],
                                },
                                {
                                  or: [
                                    {
                                      '=': [
                                        {
                                          '`': {
                                            '``': {
                                              '@$': 'researchType',
                                            },
                                          },
                                        },
                                        null,
                                      ],
                                    },
                                    {
                                      in: [
                                        {
                                          '@': 'researchType',
                                        },
                                        {
                                          '`': {
                                            '``': {
                                              '@$': 'researchType',
                                            },
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              ],
                            },
                            period: {
                              $range: {
                                end: {
                                  $date: '12/31/2022',
                                },
                                start: {
                                  $date: '1/1/2022',
                                },
                              },
                            },
                            target: 'ent:!gl_exp:!entry',
                            selection: {
                              '@.': '!amount',
                            },
                            subqueries: {
                              isInMtdc: {
                                ref: {
                                  attr: 'attr:ent#!gl_exp#!entry:!acct',
                                },
                                target: 'ent:!gl_accts:!acct',
                                selection: {
                                  '@.': '!is_in_mtdc',
                                },
                              },
                              researchType: {
                                ref: {
                                  attr: 'attr:ent#!gl_exp#!entry:!proj',
                                },
                                target: 'ent:!projects:!proj',
                                selection: {
                                  '@.': '!research_type_wfuhs',
                                },
                              },
                            },
                          },
                          expenses2023: {
                            ref: {
                              attr: 'attr:ent#!gl_exp#!entry:!proj',
                            },
                            using: 'projects',
                            filter: {
                              and: [
                                {
                                  if: [
                                    [
                                      {
                                        '=': [
                                          {
                                            '``': {
                                              '@$': 'financialVolume',
                                            },
                                          },
                                          'MTDC',
                                        ],
                                      },
                                      {
                                        '@': 'isInMtdc',
                                      },
                                    ],
                                    true,
                                  ],
                                },
                                {
                                  or: [
                                    {
                                      '=': [
                                        {
                                          '`': {
                                            '``': {
                                              '@$': 'researchType',
                                            },
                                          },
                                        },
                                        null,
                                      ],
                                    },
                                    {
                                      in: [
                                        {
                                          '@': 'researchType',
                                        },
                                        {
                                          '`': {
                                            '``': {
                                              '@$': 'researchType',
                                            },
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              ],
                            },
                            period: {
                              $range: {
                                end: {
                                  $date: '12/31/2023',
                                },
                                start: {
                                  $date: '1/1/2023',
                                },
                              },
                            },
                            target: 'ent:!gl_exp:!entry',
                            selection: {
                              '@.': '!amount',
                            },
                            subqueries: {
                              isInMtdc: {
                                ref: {
                                  attr: 'attr:ent#!gl_exp#!entry:!acct',
                                },
                                target: 'ent:!gl_accts:!acct',
                                selection: {
                                  '@.': '!is_in_mtdc',
                                },
                              },
                              researchType: {
                                ref: {
                                  attr: 'attr:ent#!gl_exp#!entry:!proj',
                                },
                                target: 'ent:!projects:!proj',
                                selection: {
                                  '@.': '!research_type_wfuhs',
                                },
                              },
                            },
                          },
                          expenses2024: {
                            ref: {
                              attr: 'attr:ent#!gl_exp#!entry:!proj',
                            },
                            using: 'projects',
                            filter: {
                              and: [
                                {
                                  if: [
                                    [
                                      {
                                        '=': [
                                          {
                                            '``': {
                                              '@$': 'financialVolume',
                                            },
                                          },
                                          'MTDC',
                                        ],
                                      },
                                      {
                                        '@': 'isInMtdc',
                                      },
                                    ],
                                    true,
                                  ],
                                },
                                {
                                  or: [
                                    {
                                      '=': [
                                        {
                                          '`': {
                                            '``': {
                                              '@$': 'researchType',
                                            },
                                          },
                                        },
                                        null,
                                      ],
                                    },
                                    {
                                      in: [
                                        {
                                          '@': 'researchType',
                                        },
                                        {
                                          '`': {
                                            '``': {
                                              '@$': 'researchType',
                                            },
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              ],
                            },
                            period: {
                              $range: {
                                end: {
                                  $date: '12/31/2024',
                                },
                                start: {
                                  $date: '1/1/2024',
                                },
                              },
                            },
                            target: 'ent:!gl_exp:!entry',
                            selection: {
                              '@.': '!amount',
                            },
                            subqueries: {
                              isInMtdc: {
                                ref: {
                                  attr: 'attr:ent#!gl_exp#!entry:!acct',
                                },
                                target: 'ent:!gl_accts:!acct',
                                selection: {
                                  '@.': '!is_in_mtdc',
                                },
                              },
                              researchType: {
                                ref: {
                                  attr: 'attr:ent#!gl_exp#!entry:!proj',
                                },
                                target: 'ent:!projects:!proj',
                                selection: {
                                  '@.': '!research_type_wfuhs',
                                },
                              },
                            },
                          },
                          projectPiAssignments: {
                            ref: {
                              attr: 'attr:ent#!proj_pis#!entry:!pi',
                            },
                            target: 'ent:!proj_pis:!entry',
                          },
                        },
                      },
                    },
                  },
                },
                query: {
                  '`': {
                    filter: {
                      or: [
                        {
                          '=': [
                            {
                              '``': {
                                '@$': 'orgRecordId',
                              },
                            },
                            null,
                          ],
                        },
                        {
                          in: [
                            {
                              '[]': [
                                {
                                  '``': {
                                    '@$': 'orgRecordId',
                                  },
                                },
                              ],
                            },
                            {
                              '@': 'projectOrgs',
                            },
                          ],
                        },
                      ],
                    },
                    target: 'ent:!personnel:!employee',
                    selection: {
                      '{}': {
                        fields: {
                          '{}': {
                            '2020': {
                              '{}': {
                                value: {
                                  '??': [
                                    {
                                      '+': {
                                        '@': 'expenses2020',
                                      },
                                    },
                                    0,
                                  ],
                                },
                              },
                            },
                            '2021': {
                              '{}': {
                                value: {
                                  '??': [
                                    {
                                      '+': {
                                        '@': 'expenses2021',
                                      },
                                    },
                                    0,
                                  ],
                                },
                              },
                            },
                            '2022': {
                              '{}': {
                                value: {
                                  '??': [
                                    {
                                      '+': {
                                        '@': 'expenses2022',
                                      },
                                    },
                                    0,
                                  ],
                                },
                              },
                            },
                            '2023': {
                              '{}': {
                                value: {
                                  '??': [
                                    {
                                      '+': {
                                        '@': 'expenses2023',
                                      },
                                    },
                                    0,
                                  ],
                                },
                              },
                            },
                            '2024': {
                              '{}': {
                                value: {
                                  '??': [
                                    {
                                      '+': {
                                        '@': 'expenses2024',
                                      },
                                    },
                                    0,
                                  ],
                                },
                              },
                            },
                            code: {
                              '{}': {
                                value: {
                                  '@.': '!code',
                                },
                              },
                            },
                            name: {
                              '{}': {
                                value: {
                                  '@.': '!name',
                                },
                              },
                            },
                          },
                        },
                      },
                    },
                    subqueries: {
                      projects: {
                        ref: {
                          attr: 'attr:ent#!proj_pis#!entry:!proj',
                        },
                        using: 'projectPiAssignments',
                        filter: {
                          or: [
                            {
                              '=': [
                                {
                                  '``': {
                                    '@$': 'orgRecordId',
                                  },
                                },
                                null,
                              ],
                            },
                            {
                              '=': [
                                {
                                  '@.': [
                                    '!org',
                                    {
                                      ref: {
                                        entity: {
                                          '``': {
                                            '@$': 'orgEntityId',
                                          },
                                        },
                                      },
                                    },
                                  ],
                                },
                                {
                                  '``': {
                                    '@$': 'orgRecordId',
                                  },
                                },
                              ],
                            },
                          ],
                        },
                        target: 'ent:!projects:!proj',
                      },
                      projectOrgs: {
                        ref: {
                          attr: 'attr:ent#!proj_pis#!entry:!proj',
                        },
                        using: 'projectPiAssignments',
                        filter: {
                          '!=': [
                            {
                              '@': 'organizations',
                            },
                            {
                              '[]': [],
                            },
                          ],
                        },
                        target: 'ent:!projects:!proj',
                        selection: {
                          '@': 'organizations',
                        },
                        subqueries: {
                          organizations: {
                            ref: {
                              attr: 'attr:ent#!projects#!proj:!org',
                            },
                            filter: {
                              if: [
                                [
                                  {
                                    '=': [
                                      {
                                        '``': {
                                          '@$': 'shouldAnalyze',
                                        },
                                      },
                                      true,
                                    ],
                                  },
                                  {
                                    '=': [
                                      {
                                        '@.': '!should_analyze',
                                      },
                                      true,
                                    ],
                                  },
                                ],
                                true,
                              ],
                            },
                            target: 'dim::!org',
                            selection: {
                              '@.': '!id',
                            },
                          },
                        },
                      },
                      expenses2020: {
                        ref: {
                          attr: 'attr:ent#!gl_exp#!entry:!proj',
                        },
                        using: 'projects',
                        filter: {
                          and: [
                            {
                              if: [
                                [
                                  {
                                    '=': [
                                      {
                                        '``': {
                                          '@$': 'financialVolume',
                                        },
                                      },
                                      'MTDC',
                                    ],
                                  },
                                  {
                                    '@': 'isInMtdc',
                                  },
                                ],
                                true,
                              ],
                            },
                            {
                              or: [
                                {
                                  '=': [
                                    {
                                      '`': {
                                        '``': {
                                          '@$': 'researchType',
                                        },
                                      },
                                    },
                                    null,
                                  ],
                                },
                                {
                                  in: [
                                    {
                                      '@': 'researchType',
                                    },
                                    {
                                      '`': {
                                        '``': {
                                          '@$': 'researchType',
                                        },
                                      },
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                        period: {
                          $range: {
                            end: {
                              $date: '12/31/2020',
                            },
                            start: {
                              $date: '1/1/2020',
                            },
                          },
                        },
                        target: 'ent:!gl_exp:!entry',
                        selection: {
                          '@.': '!amount',
                        },
                        subqueries: {
                          isInMtdc: {
                            ref: {
                              attr: 'attr:ent#!gl_exp#!entry:!acct',
                            },
                            target: 'ent:!gl_accts:!acct',
                            selection: {
                              '@.': '!is_in_mtdc',
                            },
                          },
                          researchType: {
                            ref: {
                              attr: 'attr:ent#!gl_exp#!entry:!proj',
                            },
                            target: 'ent:!projects:!proj',
                            selection: {
                              '@.': '!research_type_wfuhs',
                            },
                          },
                        },
                      },
                      expenses2021: {
                        ref: {
                          attr: 'attr:ent#!gl_exp#!entry:!proj',
                        },
                        using: 'projects',
                        filter: {
                          and: [
                            {
                              if: [
                                [
                                  {
                                    '=': [
                                      {
                                        '``': {
                                          '@$': 'financialVolume',
                                        },
                                      },
                                      'MTDC',
                                    ],
                                  },
                                  {
                                    '@': 'isInMtdc',
                                  },
                                ],
                                true,
                              ],
                            },
                            {
                              or: [
                                {
                                  '=': [
                                    {
                                      '`': {
                                        '``': {
                                          '@$': 'researchType',
                                        },
                                      },
                                    },
                                    null,
                                  ],
                                },
                                {
                                  in: [
                                    {
                                      '@': 'researchType',
                                    },
                                    {
                                      '`': {
                                        '``': {
                                          '@$': 'researchType',
                                        },
                                      },
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                        period: {
                          $range: {
                            end: {
                              $date: '12/31/2021',
                            },
                            start: {
                              $date: '1/1/2021',
                            },
                          },
                        },
                        target: 'ent:!gl_exp:!entry',
                        selection: {
                          '@.': '!amount',
                        },
                        subqueries: {
                          isInMtdc: {
                            ref: {
                              attr: 'attr:ent#!gl_exp#!entry:!acct',
                            },
                            target: 'ent:!gl_accts:!acct',
                            selection: {
                              '@.': '!is_in_mtdc',
                            },
                          },
                          researchType: {
                            ref: {
                              attr: 'attr:ent#!gl_exp#!entry:!proj',
                            },
                            target: 'ent:!projects:!proj',
                            selection: {
                              '@.': '!research_type_wfuhs',
                            },
                          },
                        },
                      },
                      expenses2022: {
                        ref: {
                          attr: 'attr:ent#!gl_exp#!entry:!proj',
                        },
                        using: 'projects',
                        filter: {
                          and: [
                            {
                              if: [
                                [
                                  {
                                    '=': [
                                      {
                                        '``': {
                                          '@$': 'financialVolume',
                                        },
                                      },
                                      'MTDC',
                                    ],
                                  },
                                  {
                                    '@': 'isInMtdc',
                                  },
                                ],
                                true,
                              ],
                            },
                            {
                              or: [
                                {
                                  '=': [
                                    {
                                      '`': {
                                        '``': {
                                          '@$': 'researchType',
                                        },
                                      },
                                    },
                                    null,
                                  ],
                                },
                                {
                                  in: [
                                    {
                                      '@': 'researchType',
                                    },
                                    {
                                      '`': {
                                        '``': {
                                          '@$': 'researchType',
                                        },
                                      },
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                        period: {
                          $range: {
                            end: {
                              $date: '12/31/2022',
                            },
                            start: {
                              $date: '1/1/2022',
                            },
                          },
                        },
                        target: 'ent:!gl_exp:!entry',
                        selection: {
                          '@.': '!amount',
                        },
                        subqueries: {
                          isInMtdc: {
                            ref: {
                              attr: 'attr:ent#!gl_exp#!entry:!acct',
                            },
                            target: 'ent:!gl_accts:!acct',
                            selection: {
                              '@.': '!is_in_mtdc',
                            },
                          },
                          researchType: {
                            ref: {
                              attr: 'attr:ent#!gl_exp#!entry:!proj',
                            },
                            target: 'ent:!projects:!proj',
                            selection: {
                              '@.': '!research_type_wfuhs',
                            },
                          },
                        },
                      },
                      expenses2023: {
                        ref: {
                          attr: 'attr:ent#!gl_exp#!entry:!proj',
                        },
                        using: 'projects',
                        filter: {
                          and: [
                            {
                              if: [
                                [
                                  {
                                    '=': [
                                      {
                                        '``': {
                                          '@$': 'financialVolume',
                                        },
                                      },
                                      'MTDC',
                                    ],
                                  },
                                  {
                                    '@': 'isInMtdc',
                                  },
                                ],
                                true,
                              ],
                            },
                            {
                              or: [
                                {
                                  '=': [
                                    {
                                      '`': {
                                        '``': {
                                          '@$': 'researchType',
                                        },
                                      },
                                    },
                                    null,
                                  ],
                                },
                                {
                                  in: [
                                    {
                                      '@': 'researchType',
                                    },
                                    {
                                      '`': {
                                        '``': {
                                          '@$': 'researchType',
                                        },
                                      },
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                        period: {
                          $range: {
                            end: {
                              $date: '12/31/2023',
                            },
                            start: {
                              $date: '1/1/2023',
                            },
                          },
                        },
                        target: 'ent:!gl_exp:!entry',
                        selection: {
                          '@.': '!amount',
                        },
                        subqueries: {
                          isInMtdc: {
                            ref: {
                              attr: 'attr:ent#!gl_exp#!entry:!acct',
                            },
                            target: 'ent:!gl_accts:!acct',
                            selection: {
                              '@.': '!is_in_mtdc',
                            },
                          },
                          researchType: {
                            ref: {
                              attr: 'attr:ent#!gl_exp#!entry:!proj',
                            },
                            target: 'ent:!projects:!proj',
                            selection: {
                              '@.': '!research_type_wfuhs',
                            },
                          },
                        },
                      },
                      expenses2024: {
                        ref: {
                          attr: 'attr:ent#!gl_exp#!entry:!proj',
                        },
                        using: 'projects',
                        filter: {
                          and: [
                            {
                              if: [
                                [
                                  {
                                    '=': [
                                      {
                                        '``': {
                                          '@$': 'financialVolume',
                                        },
                                      },
                                      'MTDC',
                                    ],
                                  },
                                  {
                                    '@': 'isInMtdc',
                                  },
                                ],
                                true,
                              ],
                            },
                            {
                              or: [
                                {
                                  '=': [
                                    {
                                      '`': {
                                        '``': {
                                          '@$': 'researchType',
                                        },
                                      },
                                    },
                                    null,
                                  ],
                                },
                                {
                                  in: [
                                    {
                                      '@': 'researchType',
                                    },
                                    {
                                      '`': {
                                        '``': {
                                          '@$': 'researchType',
                                        },
                                      },
                                    },
                                  ],
                                },
                              ],
                            },
                          ],
                        },
                        period: {
                          $range: {
                            end: {
                              $date: '12/31/2024',
                            },
                            start: {
                              $date: '1/1/2024',
                            },
                          },
                        },
                        target: 'ent:!gl_exp:!entry',
                        selection: {
                          '@.': '!amount',
                        },
                        subqueries: {
                          isInMtdc: {
                            ref: {
                              attr: 'attr:ent#!gl_exp#!entry:!acct',
                            },
                            target: 'ent:!gl_accts:!acct',
                            selection: {
                              '@.': '!is_in_mtdc',
                            },
                          },
                          researchType: {
                            ref: {
                              attr: 'attr:ent#!gl_exp#!entry:!proj',
                            },
                            target: 'ent:!projects:!proj',
                            selection: {
                              '@.': '!research_type_wfuhs',
                            },
                          },
                        },
                      },
                      projectPiAssignments: {
                        ref: {
                          attr: 'attr:ent#!proj_pis#!entry:!pi',
                        },
                        target: 'ent:!proj_pis:!entry',
                      },
                    },
                  },
                },
                columns: {
                  '[]': [
                    {
                      '{}': {
                        id: 'code',
                        direct: {
                          '{}': {
                            name: 'Code',
                            type: 'TEXT',
                          },
                        },
                      },
                    },
                    {
                      '{}': {
                        id: 'name',
                        direct: {
                          '{}': {
                            name: 'Name',
                            type: 'TEXT',
                          },
                        },
                      },
                    },
                    {
                      '{}': {
                        id: '2020',
                        direct: {
                          '{}': {
                            name: '2020',
                            type: 'CURRENCY',
                          },
                        },
                      },
                    },
                    {
                      '{}': {
                        id: '2021',
                        direct: {
                          '{}': {
                            name: '2021',
                            type: 'CURRENCY',
                          },
                        },
                      },
                    },
                    {
                      '{}': {
                        id: '2022',
                        direct: {
                          '{}': {
                            name: '2022',
                            type: 'CURRENCY',
                          },
                        },
                      },
                    },
                    {
                      '{}': {
                        id: '2023',
                        direct: {
                          '{}': {
                            name: '2023',
                            type: 'CURRENCY',
                          },
                        },
                      },
                    },
                    {
                      '{}': {
                        id: '2024',
                        direct: {
                          '{}': {
                            name: '2024',
                            type: 'CURRENCY',
                          },
                        },
                      },
                    },
                  ],
                },
                totalRow: {
                  '`': {
                    selection: {
                      '{}': {
                        fields: {
                          '{}': {
                            '2020': {
                              '{}': {
                                value: {
                                  '+': {
                                    '->': [
                                      {
                                        '@': 'records',
                                      },
                                      {
                                        '@>': [
                                          {
                                            '@$': '$value',
                                          },
                                          '2020',
                                        ],
                                      },
                                    ],
                                  },
                                },
                              },
                            },
                            '2021': {
                              '{}': {
                                value: {
                                  '+': {
                                    '->': [
                                      {
                                        '@': 'records',
                                      },
                                      {
                                        '@>': [
                                          {
                                            '@$': '$value',
                                          },
                                          '2021',
                                        ],
                                      },
                                    ],
                                  },
                                },
                              },
                            },
                            '2022': {
                              '{}': {
                                value: {
                                  '+': {
                                    '->': [
                                      {
                                        '@': 'records',
                                      },
                                      {
                                        '@>': [
                                          {
                                            '@$': '$value',
                                          },
                                          '2022',
                                        ],
                                      },
                                    ],
                                  },
                                },
                              },
                            },
                            '2023': {
                              '{}': {
                                value: {
                                  '+': {
                                    '->': [
                                      {
                                        '@': 'records',
                                      },
                                      {
                                        '@>': [
                                          {
                                            '@$': '$value',
                                          },
                                          '2023',
                                        ],
                                      },
                                    ],
                                  },
                                },
                              },
                            },
                            '2024': {
                              '{}': {
                                value: {
                                  '+': {
                                    '->': [
                                      {
                                        '@': 'records',
                                      },
                                      {
                                        '@>': [
                                          {
                                            '@$': '$value',
                                          },
                                          '2024',
                                        ],
                                      },
                                    ],
                                  },
                                },
                              },
                            },
                            code: {
                              '{}': {
                                value: 'Total',
                              },
                            },
                            name: {
                              '{}': {
                                value: 'Total',
                              },
                            },
                          },
                        },
                      },
                    },
                    subqueries: {
                      records: {
                        filter: {
                          or: [
                            {
                              '=': [
                                {
                                  '``': {
                                    '@$': 'orgRecordId',
                                  },
                                },
                                null,
                              ],
                            },
                            {
                              in: [
                                {
                                  '[]': [
                                    {
                                      '``': {
                                        '@$': 'orgRecordId',
                                      },
                                    },
                                  ],
                                },
                                {
                                  '@': 'projectOrgs',
                                },
                              ],
                            },
                          ],
                        },
                        target: 'ent:!personnel:!employee',
                        selection: {
                          '{}': {
                            '2020': {
                              '??': [
                                {
                                  '+': {
                                    '@': 'expenses2020',
                                  },
                                },
                                0,
                              ],
                            },
                            '2021': {
                              '??': [
                                {
                                  '+': {
                                    '@': 'expenses2021',
                                  },
                                },
                                0,
                              ],
                            },
                            '2022': {
                              '??': [
                                {
                                  '+': {
                                    '@': 'expenses2022',
                                  },
                                },
                                0,
                              ],
                            },
                            '2023': {
                              '??': [
                                {
                                  '+': {
                                    '@': 'expenses2023',
                                  },
                                },
                                0,
                              ],
                            },
                            '2024': {
                              '??': [
                                {
                                  '+': {
                                    '@': 'expenses2024',
                                  },
                                },
                                0,
                              ],
                            },
                          },
                        },
                        subqueries: {
                          projects: {
                            ref: {
                              attr: 'attr:ent#!proj_pis#!entry:!proj',
                            },
                            using: 'projectPiAssignments',
                            filter: {
                              or: [
                                {
                                  '=': [
                                    {
                                      '``': {
                                        '@$': 'orgRecordId',
                                      },
                                    },
                                    null,
                                  ],
                                },
                                {
                                  '=': [
                                    {
                                      '@.': [
                                        '!org',
                                        {
                                          ref: {
                                            entity: {
                                              '``': {
                                                '@$': 'orgEntityId',
                                              },
                                            },
                                          },
                                        },
                                      ],
                                    },
                                    {
                                      '``': {
                                        '@$': 'orgRecordId',
                                      },
                                    },
                                  ],
                                },
                              ],
                            },
                            target: 'ent:!projects:!proj',
                          },
                          projectOrgs: {
                            ref: {
                              attr: 'attr:ent#!proj_pis#!entry:!proj',
                            },
                            using: 'projectPiAssignments',
                            filter: {
                              '!=': [
                                {
                                  '@': 'organizations',
                                },
                                {
                                  '[]': [],
                                },
                              ],
                            },
                            target: 'ent:!projects:!proj',
                            selection: {
                              '@': 'organizations',
                            },
                            subqueries: {
                              organizations: {
                                ref: {
                                  attr: 'attr:ent#!projects#!proj:!org',
                                },
                                filter: {
                                  if: [
                                    [
                                      {
                                        '=': [
                                          {
                                            '``': {
                                              '@$': 'shouldAnalyze',
                                            },
                                          },
                                          true,
                                        ],
                                      },
                                      {
                                        '=': [
                                          {
                                            '@.': '!should_analyze',
                                          },
                                          true,
                                        ],
                                      },
                                    ],
                                    true,
                                  ],
                                },
                                target: 'dim::!org',
                                selection: {
                                  '@.': '!id',
                                },
                              },
                            },
                          },
                          expenses2020: {
                            ref: {
                              attr: 'attr:ent#!gl_exp#!entry:!proj',
                            },
                            using: 'projects',
                            filter: {
                              and: [
                                {
                                  if: [
                                    [
                                      {
                                        '=': [
                                          {
                                            '``': {
                                              '@$': 'financialVolume',
                                            },
                                          },
                                          'MTDC',
                                        ],
                                      },
                                      {
                                        '@': 'isInMtdc',
                                      },
                                    ],
                                    true,
                                  ],
                                },
                                {
                                  or: [
                                    {
                                      '=': [
                                        {
                                          '`': {
                                            '``': {
                                              '@$': 'researchType',
                                            },
                                          },
                                        },
                                        null,
                                      ],
                                    },
                                    {
                                      in: [
                                        {
                                          '@': 'researchType',
                                        },
                                        {
                                          '`': {
                                            '``': {
                                              '@$': 'researchType',
                                            },
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              ],
                            },
                            period: {
                              $range: {
                                end: {
                                  $date: '2020-12-31',
                                },
                                start: {
                                  $date: '2020-01-01',
                                },
                                includesStart: true,
                              },
                            },
                            target: 'ent:!gl_exp:!entry',
                            selection: {
                              '@.': '!amount',
                            },
                            subqueries: {
                              isInMtdc: {
                                ref: {
                                  attr: 'attr:ent#!gl_exp#!entry:!acct',
                                },
                                target: 'ent:!gl_accts:!acct',
                                selection: {
                                  '@.': '!is_in_mtdc',
                                },
                              },
                              researchType: {
                                ref: {
                                  attr: 'attr:ent#!gl_exp#!entry:!proj',
                                },
                                target: 'ent:!projects:!proj',
                                selection: {
                                  '@.': '!research_type_wfuhs',
                                },
                              },
                            },
                          },
                          expenses2021: {
                            ref: {
                              attr: 'attr:ent#!gl_exp#!entry:!proj',
                            },
                            using: 'projects',
                            filter: {
                              and: [
                                {
                                  if: [
                                    [
                                      {
                                        '=': [
                                          {
                                            '``': {
                                              '@$': 'financialVolume',
                                            },
                                          },
                                          'MTDC',
                                        ],
                                      },
                                      {
                                        '@': 'isInMtdc',
                                      },
                                    ],
                                    true,
                                  ],
                                },
                                {
                                  or: [
                                    {
                                      '=': [
                                        {
                                          '`': {
                                            '``': {
                                              '@$': 'researchType',
                                            },
                                          },
                                        },
                                        null,
                                      ],
                                    },
                                    {
                                      in: [
                                        {
                                          '@': 'researchType',
                                        },
                                        {
                                          '`': {
                                            '``': {
                                              '@$': 'researchType',
                                            },
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              ],
                            },
                            period: {
                              $range: {
                                end: {
                                  $date: '2021-12-31',
                                },
                                start: {
                                  $date: '2021-01-01',
                                },
                                includesStart: true,
                              },
                            },
                            target: 'ent:!gl_exp:!entry',
                            selection: {
                              '@.': '!amount',
                            },
                            subqueries: {
                              isInMtdc: {
                                ref: {
                                  attr: 'attr:ent#!gl_exp#!entry:!acct',
                                },
                                target: 'ent:!gl_accts:!acct',
                                selection: {
                                  '@.': '!is_in_mtdc',
                                },
                              },
                              researchType: {
                                ref: {
                                  attr: 'attr:ent#!gl_exp#!entry:!proj',
                                },
                                target: 'ent:!projects:!proj',
                                selection: {
                                  '@.': '!research_type_wfuhs',
                                },
                              },
                            },
                          },
                          expenses2022: {
                            ref: {
                              attr: 'attr:ent#!gl_exp#!entry:!proj',
                            },
                            using: 'projects',
                            filter: {
                              and: [
                                {
                                  if: [
                                    [
                                      {
                                        '=': [
                                          {
                                            '``': {
                                              '@$': 'financialVolume',
                                            },
                                          },
                                          'MTDC',
                                        ],
                                      },
                                      {
                                        '@': 'isInMtdc',
                                      },
                                    ],
                                    true,
                                  ],
                                },
                                {
                                  or: [
                                    {
                                      '=': [
                                        {
                                          '`': {
                                            '``': {
                                              '@$': 'researchType',
                                            },
                                          },
                                        },
                                        null,
                                      ],
                                    },
                                    {
                                      in: [
                                        {
                                          '@': 'researchType',
                                        },
                                        {
                                          '`': {
                                            '``': {
                                              '@$': 'researchType',
                                            },
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              ],
                            },
                            period: {
                              $range: {
                                end: {
                                  $date: '2022-12-31',
                                },
                                start: {
                                  $date: '2022-01-01',
                                },
                                includesStart: true,
                              },
                            },
                            target: 'ent:!gl_exp:!entry',
                            selection: {
                              '@.': '!amount',
                            },
                            subqueries: {
                              isInMtdc: {
                                ref: {
                                  attr: 'attr:ent#!gl_exp#!entry:!acct',
                                },
                                target: 'ent:!gl_accts:!acct',
                                selection: {
                                  '@.': '!is_in_mtdc',
                                },
                              },
                              researchType: {
                                ref: {
                                  attr: 'attr:ent#!gl_exp#!entry:!proj',
                                },
                                target: 'ent:!projects:!proj',
                                selection: {
                                  '@.': '!research_type_wfuhs',
                                },
                              },
                            },
                          },
                          expenses2023: {
                            ref: {
                              attr: 'attr:ent#!gl_exp#!entry:!proj',
                            },
                            using: 'projects',
                            filter: {
                              and: [
                                {
                                  if: [
                                    [
                                      {
                                        '=': [
                                          {
                                            '``': {
                                              '@$': 'financialVolume',
                                            },
                                          },
                                          'MTDC',
                                        ],
                                      },
                                      {
                                        '@': 'isInMtdc',
                                      },
                                    ],
                                    true,
                                  ],
                                },
                                {
                                  or: [
                                    {
                                      '=': [
                                        {
                                          '`': {
                                            '``': {
                                              '@$': 'researchType',
                                            },
                                          },
                                        },
                                        null,
                                      ],
                                    },
                                    {
                                      in: [
                                        {
                                          '@': 'researchType',
                                        },
                                        {
                                          '`': {
                                            '``': {
                                              '@$': 'researchType',
                                            },
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              ],
                            },
                            period: {
                              $range: {
                                end: {
                                  $date: '2023-12-31',
                                },
                                start: {
                                  $date: '2023-01-01',
                                },
                                includesStart: true,
                              },
                            },
                            target: 'ent:!gl_exp:!entry',
                            selection: {
                              '@.': '!amount',
                            },
                            subqueries: {
                              isInMtdc: {
                                ref: {
                                  attr: 'attr:ent#!gl_exp#!entry:!acct',
                                },
                                target: 'ent:!gl_accts:!acct',
                                selection: {
                                  '@.': '!is_in_mtdc',
                                },
                              },
                              researchType: {
                                ref: {
                                  attr: 'attr:ent#!gl_exp#!entry:!proj',
                                },
                                target: 'ent:!projects:!proj',
                                selection: {
                                  '@.': '!research_type_wfuhs',
                                },
                              },
                            },
                          },
                          expenses2024: {
                            ref: {
                              attr: 'attr:ent#!gl_exp#!entry:!proj',
                            },
                            using: 'projects',
                            filter: {
                              and: [
                                {
                                  if: [
                                    [
                                      {
                                        '=': [
                                          {
                                            '``': {
                                              '@$': 'financialVolume',
                                            },
                                          },
                                          'MTDC',
                                        ],
                                      },
                                      {
                                        '@': 'isInMtdc',
                                      },
                                    ],
                                    true,
                                  ],
                                },
                                {
                                  or: [
                                    {
                                      '=': [
                                        {
                                          '`': {
                                            '``': {
                                              '@$': 'researchType',
                                            },
                                          },
                                        },
                                        null,
                                      ],
                                    },
                                    {
                                      in: [
                                        {
                                          '@': 'researchType',
                                        },
                                        {
                                          '`': {
                                            '``': {
                                              '@$': 'researchType',
                                            },
                                          },
                                        },
                                      ],
                                    },
                                  ],
                                },
                              ],
                            },
                            period: {
                              $range: {
                                end: {
                                  $date: '2024-12-31',
                                },
                                start: {
                                  $date: '2024-01-01',
                                },
                                includesStart: true,
                              },
                            },
                            target: 'ent:!gl_exp:!entry',
                            selection: {
                              '@.': '!amount',
                            },
                            subqueries: {
                              isInMtdc: {
                                ref: {
                                  attr: 'attr:ent#!gl_exp#!entry:!acct',
                                },
                                target: 'ent:!gl_accts:!acct',
                                selection: {
                                  '@.': '!is_in_mtdc',
                                },
                              },
                              researchType: {
                                ref: {
                                  attr: 'attr:ent#!gl_exp#!entry:!proj',
                                },
                                target: 'ent:!projects:!proj',
                                selection: {
                                  '@.': '!research_type_wfuhs',
                                },
                              },
                            },
                          },
                          projectPiAssignments: {
                            ref: {
                              attr: 'attr:ent#!proj_pis#!entry:!pi',
                            },
                            target: 'ent:!proj_pis:!entry',
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          ],
          {
            '{}': {
              count: {
                '`': {
                  selection: {
                    '#': {
                      '@': 'orgs',
                    },
                  },
                  subqueries: {
                    orgs: {
                      filter: {
                        and: [
                          {
                            '!=': [
                              {
                                '@.': '!id',
                              },
                              '?224',
                            ],
                          },
                          {
                            '=': [
                              {
                                '@^': 'parent',
                              },
                              {
                                '``': {
                                  '@$': 'orgRecordId',
                                },
                              },
                            ],
                          },
                          {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '``': {
                                        '@$': 'shouldAnalyze',
                                      },
                                    },
                                    true,
                                  ],
                                },
                                {
                                  '=': [
                                    {
                                      '@.': '!should_analyze',
                                    },
                                    true,
                                  ],
                                },
                              ],
                              true,
                            ],
                          },
                        ],
                      },
                      target: 'dim::!org',
                      selection: {
                        '@.': '!id',
                      },
                      subqueries: {
                        expenses2020: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          using: 'projectAssignments',
                          filter: {
                            and: [
                              {
                                if: [
                                  [
                                    {
                                      '=': [
                                        {
                                          '``': {
                                            '@$': 'financialVolume',
                                          },
                                        },
                                        'MTDC',
                                      ],
                                    },
                                    {
                                      '@': 'isInMtdc',
                                    },
                                  ],
                                  true,
                                ],
                              },
                              {
                                or: [
                                  {
                                    '=': [
                                      {
                                        '`': {
                                          '``': {
                                            '@$': 'researchType',
                                          },
                                        },
                                      },
                                      null,
                                    ],
                                  },
                                  {
                                    in: [
                                      {
                                        '@': 'researchType',
                                      },
                                      {
                                        '`': {
                                          '``': {
                                            '@$': 'researchType',
                                          },
                                        },
                                      },
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                          period: {
                            $range: {
                              end: {
                                $date: '12/31/2020',
                              },
                              start: {
                                $date: '1/1/2020',
                              },
                            },
                          },
                          target: 'ent:!gl_exp:!entry',
                          selection: {
                            '@.': '!amount',
                          },
                          subqueries: {
                            isInMtdc: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!acct',
                              },
                              target: 'ent:!gl_accts:!acct',
                              selection: {
                                '@.': '!is_in_mtdc',
                              },
                            },
                            researchType: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!proj',
                              },
                              target: 'ent:!projects:!proj',
                              selection: {
                                '@.': '!research_type_wfuhs',
                              },
                            },
                          },
                        },
                        expenses2021: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          using: 'projectAssignments',
                          filter: {
                            and: [
                              {
                                if: [
                                  [
                                    {
                                      '=': [
                                        {
                                          '``': {
                                            '@$': 'financialVolume',
                                          },
                                        },
                                        'MTDC',
                                      ],
                                    },
                                    {
                                      '@': 'isInMtdc',
                                    },
                                  ],
                                  true,
                                ],
                              },
                              {
                                or: [
                                  {
                                    '=': [
                                      {
                                        '`': {
                                          '``': {
                                            '@$': 'researchType',
                                          },
                                        },
                                      },
                                      null,
                                    ],
                                  },
                                  {
                                    in: [
                                      {
                                        '@': 'researchType',
                                      },
                                      {
                                        '`': {
                                          '``': {
                                            '@$': 'researchType',
                                          },
                                        },
                                      },
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                          period: {
                            $range: {
                              end: {
                                $date: '12/31/2021',
                              },
                              start: {
                                $date: '1/1/2021',
                              },
                            },
                          },
                          target: 'ent:!gl_exp:!entry',
                          selection: {
                            '@.': '!amount',
                          },
                          subqueries: {
                            isInMtdc: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!acct',
                              },
                              target: 'ent:!gl_accts:!acct',
                              selection: {
                                '@.': '!is_in_mtdc',
                              },
                            },
                            researchType: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!proj',
                              },
                              target: 'ent:!projects:!proj',
                              selection: {
                                '@.': '!research_type_wfuhs',
                              },
                            },
                          },
                        },
                        expenses2022: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          using: 'projectAssignments',
                          filter: {
                            and: [
                              {
                                if: [
                                  [
                                    {
                                      '=': [
                                        {
                                          '``': {
                                            '@$': 'financialVolume',
                                          },
                                        },
                                        'MTDC',
                                      ],
                                    },
                                    {
                                      '@': 'isInMtdc',
                                    },
                                  ],
                                  true,
                                ],
                              },
                              {
                                or: [
                                  {
                                    '=': [
                                      {
                                        '`': {
                                          '``': {
                                            '@$': 'researchType',
                                          },
                                        },
                                      },
                                      null,
                                    ],
                                  },
                                  {
                                    in: [
                                      {
                                        '@': 'researchType',
                                      },
                                      {
                                        '`': {
                                          '``': {
                                            '@$': 'researchType',
                                          },
                                        },
                                      },
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                          period: {
                            $range: {
                              end: {
                                $date: '12/31/2022',
                              },
                              start: {
                                $date: '1/1/2022',
                              },
                            },
                          },
                          target: 'ent:!gl_exp:!entry',
                          selection: {
                            '@.': '!amount',
                          },
                          subqueries: {
                            isInMtdc: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!acct',
                              },
                              target: 'ent:!gl_accts:!acct',
                              selection: {
                                '@.': '!is_in_mtdc',
                              },
                            },
                            researchType: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!proj',
                              },
                              target: 'ent:!projects:!proj',
                              selection: {
                                '@.': '!research_type_wfuhs',
                              },
                            },
                          },
                        },
                        expenses2023: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          using: 'projectAssignments',
                          filter: {
                            and: [
                              {
                                if: [
                                  [
                                    {
                                      '=': [
                                        {
                                          '``': {
                                            '@$': 'financialVolume',
                                          },
                                        },
                                        'MTDC',
                                      ],
                                    },
                                    {
                                      '@': 'isInMtdc',
                                    },
                                  ],
                                  true,
                                ],
                              },
                              {
                                or: [
                                  {
                                    '=': [
                                      {
                                        '`': {
                                          '``': {
                                            '@$': 'researchType',
                                          },
                                        },
                                      },
                                      null,
                                    ],
                                  },
                                  {
                                    in: [
                                      {
                                        '@': 'researchType',
                                      },
                                      {
                                        '`': {
                                          '``': {
                                            '@$': 'researchType',
                                          },
                                        },
                                      },
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                          period: {
                            $range: {
                              end: {
                                $date: '12/31/2023',
                              },
                              start: {
                                $date: '1/1/2023',
                              },
                            },
                          },
                          target: 'ent:!gl_exp:!entry',
                          selection: {
                            '@.': '!amount',
                          },
                          subqueries: {
                            isInMtdc: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!acct',
                              },
                              target: 'ent:!gl_accts:!acct',
                              selection: {
                                '@.': '!is_in_mtdc',
                              },
                            },
                            researchType: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!proj',
                              },
                              target: 'ent:!projects:!proj',
                              selection: {
                                '@.': '!research_type_wfuhs',
                              },
                            },
                          },
                        },
                        expenses2024: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          using: 'projectAssignments',
                          filter: {
                            and: [
                              {
                                if: [
                                  [
                                    {
                                      '=': [
                                        {
                                          '``': {
                                            '@$': 'financialVolume',
                                          },
                                        },
                                        'MTDC',
                                      ],
                                    },
                                    {
                                      '@': 'isInMtdc',
                                    },
                                  ],
                                  true,
                                ],
                              },
                              {
                                or: [
                                  {
                                    '=': [
                                      {
                                        '`': {
                                          '``': {
                                            '@$': 'researchType',
                                          },
                                        },
                                      },
                                      null,
                                    ],
                                  },
                                  {
                                    in: [
                                      {
                                        '@': 'researchType',
                                      },
                                      {
                                        '`': {
                                          '``': {
                                            '@$': 'researchType',
                                          },
                                        },
                                      },
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                          period: {
                            $range: {
                              end: {
                                $date: '12/31/2024',
                              },
                              start: {
                                $date: '1/1/2024',
                              },
                            },
                          },
                          target: 'ent:!gl_exp:!entry',
                          selection: {
                            '@.': '!amount',
                          },
                          subqueries: {
                            isInMtdc: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!acct',
                              },
                              target: 'ent:!gl_accts:!acct',
                              selection: {
                                '@.': '!is_in_mtdc',
                              },
                            },
                            researchType: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!proj',
                              },
                              target: 'ent:!projects:!proj',
                              selection: {
                                '@.': '!research_type_wfuhs',
                              },
                            },
                          },
                        },
                        projectAssignments: {
                          ref: {
                            attr: 'attr:ent#!projects#!proj:!org',
                            inherit: '-',
                          },
                          target: 'ent:!projects:!proj',
                        },
                      },
                    },
                  },
                },
              },
              query: {
                '`': {
                  filter: {
                    and: [
                      {
                        '!=': [
                          {
                            '@.': '!id',
                          },
                          '?224',
                        ],
                      },
                      {
                        '=': [
                          {
                            '@^': 'parent',
                          },
                          {
                            '``': {
                              '@$': 'orgRecordId',
                            },
                          },
                        ],
                      },
                      {
                        if: [
                          [
                            {
                              '=': [
                                {
                                  '``': {
                                    '@$': 'shouldAnalyze',
                                  },
                                },
                                true,
                              ],
                            },
                            {
                              '=': [
                                {
                                  '@.': '!should_analyze',
                                },
                                true,
                              ],
                            },
                          ],
                          true,
                        ],
                      },
                    ],
                  },
                  target: 'dim::!org',
                  selection: {
                    '{}': {
                      fields: {
                        '{}': {
                          '2020': {
                            '{}': {
                              value: {
                                '??': [
                                  {
                                    '+': {
                                      '@': 'expenses2020',
                                    },
                                  },
                                  0,
                                ],
                              },
                            },
                          },
                          '2021': {
                            '{}': {
                              value: {
                                '??': [
                                  {
                                    '+': {
                                      '@': 'expenses2021',
                                    },
                                  },
                                  0,
                                ],
                              },
                            },
                          },
                          '2022': {
                            '{}': {
                              value: {
                                '??': [
                                  {
                                    '+': {
                                      '@': 'expenses2022',
                                    },
                                  },
                                  0,
                                ],
                              },
                            },
                          },
                          '2023': {
                            '{}': {
                              value: {
                                '??': [
                                  {
                                    '+': {
                                      '@': 'expenses2023',
                                    },
                                  },
                                  0,
                                ],
                              },
                            },
                          },
                          '2024': {
                            '{}': {
                              value: {
                                '??': [
                                  {
                                    '+': {
                                      '@': 'expenses2024',
                                    },
                                  },
                                  0,
                                ],
                              },
                            },
                          },
                          code: {
                            '{}': {
                              value: {
                                '@.': '!code',
                              },
                            },
                          },
                          name: {
                            '{}': {
                              value: {
                                '@.': '!name',
                              },
                            },
                          },
                        },
                      },
                      onClick: {
                        '{}': {
                          action: {
                            '{}': {
                              payload: {
                                '{}': {
                                  goto: {
                                    '{}': {
                                      variables: {
                                        '{}': {
                                          title: {
                                            if: [
                                              [
                                                {
                                                  and: [
                                                    {
                                                      not: {
                                                        '=': [
                                                          {
                                                            '@': 'hasChild',
                                                          },
                                                          null,
                                                        ],
                                                      },
                                                    },
                                                    {
                                                      not: {
                                                        '=': [
                                                          {
                                                            '@': 'hasChild',
                                                          },
                                                          {
                                                            '[]': [],
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                                'Subdepartments',
                                              ],
                                              'PIs',
                                            ],
                                          },
                                          piSwitch: {
                                            if: [
                                              [
                                                {
                                                  and: [
                                                    {
                                                      not: {
                                                        '=': [
                                                          {
                                                            '@': 'hasChild',
                                                          },
                                                          null,
                                                        ],
                                                      },
                                                    },
                                                    {
                                                      not: {
                                                        '=': [
                                                          {
                                                            '@': 'hasChild',
                                                          },
                                                          {
                                                            '[]': [],
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                                false,
                                              ],
                                              true,
                                            ],
                                          },
                                          orgEntityId: {
                                            '@_': 'id',
                                          },
                                          orgRecordId: {
                                            '@.': '!id',
                                          },
                                        },
                                      },
                                      navigationId: 'trends',
                                    },
                                  },
                                },
                              },
                              operation: 'ui.navigate',
                            },
                          },
                        },
                      },
                    },
                  },
                  subqueries: {
                    hasChild: {
                      target: 'child',
                      selection: true,
                    },
                    expenses2020: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      using: 'projectAssignments',
                      filter: {
                        and: [
                          {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '``': {
                                        '@$': 'financialVolume',
                                      },
                                    },
                                    'MTDC',
                                  ],
                                },
                                {
                                  '@': 'isInMtdc',
                                },
                              ],
                              true,
                            ],
                          },
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'researchType',
                                      },
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                in: [
                                  {
                                    '@': 'researchType',
                                  },
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'researchType',
                                      },
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                      period: {
                        $range: {
                          end: {
                            $date: '12/31/2020',
                          },
                          start: {
                            $date: '1/1/2020',
                          },
                        },
                      },
                      target: 'ent:!gl_exp:!entry',
                      selection: {
                        '@.': '!amount',
                      },
                      subqueries: {
                        isInMtdc: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!acct',
                          },
                          target: 'ent:!gl_accts:!acct',
                          selection: {
                            '@.': '!is_in_mtdc',
                          },
                        },
                        researchType: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          target: 'ent:!projects:!proj',
                          selection: {
                            '@.': '!research_type_wfuhs',
                          },
                        },
                      },
                    },
                    expenses2021: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      using: 'projectAssignments',
                      filter: {
                        and: [
                          {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '``': {
                                        '@$': 'financialVolume',
                                      },
                                    },
                                    'MTDC',
                                  ],
                                },
                                {
                                  '@': 'isInMtdc',
                                },
                              ],
                              true,
                            ],
                          },
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'researchType',
                                      },
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                in: [
                                  {
                                    '@': 'researchType',
                                  },
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'researchType',
                                      },
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                      period: {
                        $range: {
                          end: {
                            $date: '12/31/2021',
                          },
                          start: {
                            $date: '1/1/2021',
                          },
                        },
                      },
                      target: 'ent:!gl_exp:!entry',
                      selection: {
                        '@.': '!amount',
                      },
                      subqueries: {
                        isInMtdc: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!acct',
                          },
                          target: 'ent:!gl_accts:!acct',
                          selection: {
                            '@.': '!is_in_mtdc',
                          },
                        },
                        researchType: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          target: 'ent:!projects:!proj',
                          selection: {
                            '@.': '!research_type_wfuhs',
                          },
                        },
                      },
                    },
                    expenses2022: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      using: 'projectAssignments',
                      filter: {
                        and: [
                          {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '``': {
                                        '@$': 'financialVolume',
                                      },
                                    },
                                    'MTDC',
                                  ],
                                },
                                {
                                  '@': 'isInMtdc',
                                },
                              ],
                              true,
                            ],
                          },
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'researchType',
                                      },
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                in: [
                                  {
                                    '@': 'researchType',
                                  },
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'researchType',
                                      },
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                      period: {
                        $range: {
                          end: {
                            $date: '12/31/2022',
                          },
                          start: {
                            $date: '1/1/2022',
                          },
                        },
                      },
                      target: 'ent:!gl_exp:!entry',
                      selection: {
                        '@.': '!amount',
                      },
                      subqueries: {
                        isInMtdc: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!acct',
                          },
                          target: 'ent:!gl_accts:!acct',
                          selection: {
                            '@.': '!is_in_mtdc',
                          },
                        },
                        researchType: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          target: 'ent:!projects:!proj',
                          selection: {
                            '@.': '!research_type_wfuhs',
                          },
                        },
                      },
                    },
                    expenses2023: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      using: 'projectAssignments',
                      filter: {
                        and: [
                          {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '``': {
                                        '@$': 'financialVolume',
                                      },
                                    },
                                    'MTDC',
                                  ],
                                },
                                {
                                  '@': 'isInMtdc',
                                },
                              ],
                              true,
                            ],
                          },
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'researchType',
                                      },
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                in: [
                                  {
                                    '@': 'researchType',
                                  },
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'researchType',
                                      },
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                      period: {
                        $range: {
                          end: {
                            $date: '12/31/2023',
                          },
                          start: {
                            $date: '1/1/2023',
                          },
                        },
                      },
                      target: 'ent:!gl_exp:!entry',
                      selection: {
                        '@.': '!amount',
                      },
                      subqueries: {
                        isInMtdc: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!acct',
                          },
                          target: 'ent:!gl_accts:!acct',
                          selection: {
                            '@.': '!is_in_mtdc',
                          },
                        },
                        researchType: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          target: 'ent:!projects:!proj',
                          selection: {
                            '@.': '!research_type_wfuhs',
                          },
                        },
                      },
                    },
                    expenses2024: {
                      ref: {
                        attr: 'attr:ent#!gl_exp#!entry:!proj',
                      },
                      using: 'projectAssignments',
                      filter: {
                        and: [
                          {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '``': {
                                        '@$': 'financialVolume',
                                      },
                                    },
                                    'MTDC',
                                  ],
                                },
                                {
                                  '@': 'isInMtdc',
                                },
                              ],
                              true,
                            ],
                          },
                          {
                            or: [
                              {
                                '=': [
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'researchType',
                                      },
                                    },
                                  },
                                  null,
                                ],
                              },
                              {
                                in: [
                                  {
                                    '@': 'researchType',
                                  },
                                  {
                                    '`': {
                                      '``': {
                                        '@$': 'researchType',
                                      },
                                    },
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                      period: {
                        $range: {
                          end: {
                            $date: '12/31/2024',
                          },
                          start: {
                            $date: '1/1/2024',
                          },
                        },
                      },
                      target: 'ent:!gl_exp:!entry',
                      selection: {
                        '@.': '!amount',
                      },
                      subqueries: {
                        isInMtdc: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!acct',
                          },
                          target: 'ent:!gl_accts:!acct',
                          selection: {
                            '@.': '!is_in_mtdc',
                          },
                        },
                        researchType: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          target: 'ent:!projects:!proj',
                          selection: {
                            '@.': '!research_type_wfuhs',
                          },
                        },
                      },
                    },
                    projectAssignments: {
                      ref: {
                        attr: 'attr:ent#!projects#!proj:!org',
                        inherit: '-',
                      },
                      target: 'ent:!projects:!proj',
                    },
                  },
                },
              },
              columns: {
                '[]': [
                  {
                    '{}': {
                      id: 'code',
                      direct: {
                        '{}': {
                          name: 'Code',
                          type: 'TEXT',
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      id: 'name',
                      direct: {
                        '{}': {
                          name: 'Name',
                          type: 'TEXT',
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      id: '2020',
                      direct: {
                        '{}': {
                          name: '2020',
                          type: 'CURRENCY',
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      id: '2021',
                      direct: {
                        '{}': {
                          name: '2021',
                          type: 'CURRENCY',
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      id: '2022',
                      direct: {
                        '{}': {
                          name: '2022',
                          type: 'CURRENCY',
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      id: '2023',
                      direct: {
                        '{}': {
                          name: '2023',
                          type: 'CURRENCY',
                        },
                      },
                    },
                  },
                  {
                    '{}': {
                      id: '2024',
                      direct: {
                        '{}': {
                          name: '2024',
                          type: 'CURRENCY',
                        },
                      },
                    },
                  },
                ],
              },
              totalRow: {
                '`': {
                  selection: {
                    '{}': {
                      fields: {
                        '{}': {
                          '2020': {
                            '{}': {
                              value: {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        '2020',
                                      ],
                                    },
                                  ],
                                },
                              },
                            },
                          },
                          '2021': {
                            '{}': {
                              value: {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        '2021',
                                      ],
                                    },
                                  ],
                                },
                              },
                            },
                          },
                          '2022': {
                            '{}': {
                              value: {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        '2022',
                                      ],
                                    },
                                  ],
                                },
                              },
                            },
                          },
                          '2023': {
                            '{}': {
                              value: {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        '2023',
                                      ],
                                    },
                                  ],
                                },
                              },
                            },
                          },
                          '2024': {
                            '{}': {
                              value: {
                                '+': {
                                  '->': [
                                    {
                                      '@': 'records',
                                    },
                                    {
                                      '@>': [
                                        {
                                          '@$': '$value',
                                        },
                                        '2024',
                                      ],
                                    },
                                  ],
                                },
                              },
                            },
                          },
                          code: {
                            '{}': {
                              value: 'Total',
                            },
                          },
                          name: {
                            '{}': {
                              value: 'Total',
                            },
                          },
                        },
                      },
                    },
                  },
                  subqueries: {
                    records: {
                      filter: {
                        and: [
                          {
                            '=': [
                              {
                                '@^': 'parent',
                              },
                              {
                                '``': {
                                  '@$': 'orgRecordId',
                                },
                              },
                            ],
                          },
                          {
                            if: [
                              [
                                {
                                  '=': [
                                    {
                                      '``': {
                                        '@$': 'shouldAnalyze',
                                      },
                                    },
                                    true,
                                  ],
                                },
                                {
                                  '=': [
                                    {
                                      '@.': '!should_analyze',
                                    },
                                    true,
                                  ],
                                },
                              ],
                              true,
                            ],
                          },
                        ],
                      },
                      target: 'dim::!org',
                      selection: {
                        '{}': {
                          '2020': {
                            '??': [
                              {
                                '+': {
                                  '@': 'expenses2020',
                                },
                              },
                              0,
                            ],
                          },
                          '2021': {
                            '??': [
                              {
                                '+': {
                                  '@': 'expenses2021',
                                },
                              },
                              0,
                            ],
                          },
                          '2022': {
                            '??': [
                              {
                                '+': {
                                  '@': 'expenses2022',
                                },
                              },
                              0,
                            ],
                          },
                          '2023': {
                            '??': [
                              {
                                '+': {
                                  '@': 'expenses2023',
                                },
                              },
                              0,
                            ],
                          },
                          '2024': {
                            '??': [
                              {
                                '+': {
                                  '@': 'expenses2024',
                                },
                              },
                              0,
                            ],
                          },
                        },
                      },
                      subqueries: {
                        expenses2020: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          using: 'projectAssignments',
                          filter: {
                            and: [
                              {
                                if: [
                                  [
                                    {
                                      '=': [
                                        {
                                          '``': {
                                            '@$': 'financialVolume',
                                          },
                                        },
                                        'MTDC',
                                      ],
                                    },
                                    {
                                      '@': 'isInMtdc',
                                    },
                                  ],
                                  true,
                                ],
                              },
                              {
                                or: [
                                  {
                                    '=': [
                                      {
                                        '`': {
                                          '``': {
                                            '@$': 'researchType',
                                          },
                                        },
                                      },
                                      null,
                                    ],
                                  },
                                  {
                                    in: [
                                      {
                                        '@': 'researchType',
                                      },
                                      {
                                        '`': {
                                          '``': {
                                            '@$': 'researchType',
                                          },
                                        },
                                      },
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                          period: {
                            $range: {
                              end: {
                                $date: '2020-12-31',
                              },
                              start: {
                                $date: '2020-01-01',
                              },
                              includesStart: true,
                            },
                          },
                          target: 'ent:!gl_exp:!entry',
                          selection: {
                            '@.': '!amount',
                          },
                          subqueries: {
                            isInMtdc: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!acct',
                              },
                              target: 'ent:!gl_accts:!acct',
                              selection: {
                                '@.': '!is_in_mtdc',
                              },
                            },
                            researchType: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!proj',
                              },
                              target: 'ent:!projects:!proj',
                              selection: {
                                '@.': '!research_type_wfuhs',
                              },
                            },
                          },
                        },
                        expenses2021: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          using: 'projectAssignments',
                          filter: {
                            and: [
                              {
                                if: [
                                  [
                                    {
                                      '=': [
                                        {
                                          '``': {
                                            '@$': 'financialVolume',
                                          },
                                        },
                                        'MTDC',
                                      ],
                                    },
                                    {
                                      '@': 'isInMtdc',
                                    },
                                  ],
                                  true,
                                ],
                              },
                              {
                                or: [
                                  {
                                    '=': [
                                      {
                                        '`': {
                                          '``': {
                                            '@$': 'researchType',
                                          },
                                        },
                                      },
                                      null,
                                    ],
                                  },
                                  {
                                    in: [
                                      {
                                        '@': 'researchType',
                                      },
                                      {
                                        '`': {
                                          '``': {
                                            '@$': 'researchType',
                                          },
                                        },
                                      },
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                          period: {
                            $range: {
                              end: {
                                $date: '2021-12-31',
                              },
                              start: {
                                $date: '2021-01-01',
                              },
                              includesStart: true,
                            },
                          },
                          target: 'ent:!gl_exp:!entry',
                          selection: {
                            '@.': '!amount',
                          },
                          subqueries: {
                            isInMtdc: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!acct',
                              },
                              target: 'ent:!gl_accts:!acct',
                              selection: {
                                '@.': '!is_in_mtdc',
                              },
                            },
                            researchType: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!proj',
                              },
                              target: 'ent:!projects:!proj',
                              selection: {
                                '@.': '!research_type_wfuhs',
                              },
                            },
                          },
                        },
                        expenses2022: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          using: 'projectAssignments',
                          filter: {
                            and: [
                              {
                                if: [
                                  [
                                    {
                                      '=': [
                                        {
                                          '``': {
                                            '@$': 'financialVolume',
                                          },
                                        },
                                        'MTDC',
                                      ],
                                    },
                                    {
                                      '@': 'isInMtdc',
                                    },
                                  ],
                                  true,
                                ],
                              },
                              {
                                or: [
                                  {
                                    '=': [
                                      {
                                        '`': {
                                          '``': {
                                            '@$': 'researchType',
                                          },
                                        },
                                      },
                                      null,
                                    ],
                                  },
                                  {
                                    in: [
                                      {
                                        '@': 'researchType',
                                      },
                                      {
                                        '`': {
                                          '``': {
                                            '@$': 'researchType',
                                          },
                                        },
                                      },
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                          period: {
                            $range: {
                              end: {
                                $date: '2022-12-31',
                              },
                              start: {
                                $date: '2022-01-01',
                              },
                              includesStart: true,
                            },
                          },
                          target: 'ent:!gl_exp:!entry',
                          selection: {
                            '@.': '!amount',
                          },
                          subqueries: {
                            isInMtdc: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!acct',
                              },
                              target: 'ent:!gl_accts:!acct',
                              selection: {
                                '@.': '!is_in_mtdc',
                              },
                            },
                            researchType: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!proj',
                              },
                              target: 'ent:!projects:!proj',
                              selection: {
                                '@.': '!research_type_wfuhs',
                              },
                            },
                          },
                        },
                        expenses2023: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          using: 'projectAssignments',
                          filter: {
                            and: [
                              {
                                if: [
                                  [
                                    {
                                      '=': [
                                        {
                                          '``': {
                                            '@$': 'financialVolume',
                                          },
                                        },
                                        'MTDC',
                                      ],
                                    },
                                    {
                                      '@': 'isInMtdc',
                                    },
                                  ],
                                  true,
                                ],
                              },
                              {
                                or: [
                                  {
                                    '=': [
                                      {
                                        '`': {
                                          '``': {
                                            '@$': 'researchType',
                                          },
                                        },
                                      },
                                      null,
                                    ],
                                  },
                                  {
                                    in: [
                                      {
                                        '@': 'researchType',
                                      },
                                      {
                                        '`': {
                                          '``': {
                                            '@$': 'researchType',
                                          },
                                        },
                                      },
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                          period: {
                            $range: {
                              end: {
                                $date: '2023-12-31',
                              },
                              start: {
                                $date: '2023-01-01',
                              },
                              includesStart: true,
                            },
                          },
                          target: 'ent:!gl_exp:!entry',
                          selection: {
                            '@.': '!amount',
                          },
                          subqueries: {
                            isInMtdc: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!acct',
                              },
                              target: 'ent:!gl_accts:!acct',
                              selection: {
                                '@.': '!is_in_mtdc',
                              },
                            },
                            researchType: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!proj',
                              },
                              target: 'ent:!projects:!proj',
                              selection: {
                                '@.': '!research_type_wfuhs',
                              },
                            },
                          },
                        },
                        expenses2024: {
                          ref: {
                            attr: 'attr:ent#!gl_exp#!entry:!proj',
                          },
                          using: 'projectAssignments',
                          filter: {
                            and: [
                              {
                                if: [
                                  [
                                    {
                                      '=': [
                                        {
                                          '``': {
                                            '@$': 'financialVolume',
                                          },
                                        },
                                        'MTDC',
                                      ],
                                    },
                                    {
                                      '@': 'isInMtdc',
                                    },
                                  ],
                                  true,
                                ],
                              },
                              {
                                or: [
                                  {
                                    '=': [
                                      {
                                        '`': {
                                          '``': {
                                            '@$': 'researchType',
                                          },
                                        },
                                      },
                                      null,
                                    ],
                                  },
                                  {
                                    in: [
                                      {
                                        '@': 'researchType',
                                      },
                                      {
                                        '`': {
                                          '``': {
                                            '@$': 'researchType',
                                          },
                                        },
                                      },
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                          period: {
                            $range: {
                              end: {
                                $date: '2024-12-31',
                              },
                              start: {
                                $date: '2024-01-01',
                              },
                              includesStart: true,
                            },
                          },
                          target: 'ent:!gl_exp:!entry',
                          selection: {
                            '@.': '!amount',
                          },
                          subqueries: {
                            isInMtdc: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!acct',
                              },
                              target: 'ent:!gl_accts:!acct',
                              selection: {
                                '@.': '!is_in_mtdc',
                              },
                            },
                            researchType: {
                              ref: {
                                attr: 'attr:ent#!gl_exp#!entry:!proj',
                              },
                              target: 'ent:!projects:!proj',
                              selection: {
                                '@.': '!research_type_wfuhs',
                              },
                            },
                          },
                        },
                        projectAssignments: {
                          ref: {
                            attr: 'attr:ent#!projects#!proj:!org',
                            inherit: '-',
                          },
                          target: 'ent:!projects:!proj',
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        ],
      },
    },
  },
  variables: {
    title: 'Departments',
    piSwitch: false,
    researchType: ['BASIC RESEARCH'],
    shouldAnalyze: true,
    financialVolume: 'MTDC',
  },
}
